/**
 * Escape a user-supplied value for safe interpolation into a Dynamic LINQ double-quoted
 * string literal (e.g. `Name.ToLower().Contains("<escaped>")`).
 *
 * Escapes rather than strips, so a search term that legitimately contains a quote or a
 * backslash is still searchable (stripping would silently change what the user asked for).
 * Backslashes must be doubled first, otherwise the backslash this function adds in front of
 * a quote would itself be re-escaped.
 *
 * This is the only Dynamic-LINQ injection defense standing between free-text search input
 * and the `FullyQualifiedFilters` query param on every list page that builds its own
 * search-only filter string (Units, Tenants, Service Requests, Contractors, Manage Users,
 * Feedback, Payee Accounts, ...). It lives here — rather than in a service module that may
 * be deleted once the generated `@propertelligent/client-api` SDK is regenerated — so
 * deleting that interim module can never silently reinstate the injection surface.
 */
export const escapeDynamicLinqStringLiteral = (value: string): string =>
  value.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
